import classNames from 'classnames';
import Moment from 'moment';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import DisplayErrorMessage from '../../../common/components/misc/DisplayErrorMessage';
import DisplayLoading from '../../../common/components/misc/DisplayLoading';
import { Service } from '../../../common/services/events';
import { EventDTO } from '../../../common/types/dto/EventDTO';
import { iframeScrollToTop } from '../../../common/utils/Utils';
import { RootState } from '../../base/RootReducer';
import { config } from '../../common/';
import CardsResizer from '../../common/Components/CardsResizer';
import { AppThunkDispatch } from '../../common/types';

interface ReduxStateProps {
    isCommunicating: boolean;
    eventsError: boolean;
    events: EventDTO[];
    isFollowing: boolean;
}

interface ReduxDispatchProps {
    serviceActions: Service.ServiceActions;
}

type EventsProperties =
    ReduxStateProps
    & ReduxDispatchProps;

const Events: React.FC<EventsProperties> = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (props.events.length === 0) {
            props.serviceActions.getEvents();
        }
    }, [props.events.length]);

    const openWindow = (url: string) => {
        // window.open(url '_blank');
        iframeScrollToTop();
        window.location.href = url;
    };

    const redirectToSignup = (data: EventDTO) => {
        props.serviceActions.followSignup(data).then((response) => {
            if (data.url_inscricao_convite) {
                if (response.multipleUid && response.multipleUid !== '') {
                    if (data.url_inscricao_convite.indexOf('?') > -1) {
                        openWindow(data.url_inscricao_convite + '&followuid=' + response.multipleUid);
                    } else {
                        openWindow(data.url_inscricao_convite + '?followuid=' + response.multipleUid);
                    }
                } else {
                    openWindow(data.url_inscricao_convite);
                }
            }
        });
    };

    const buildEventsList = () => {
        if (props.events.length > 0) {
            const table: JSX.Element[] = [];
            let content = null;

            props.events.forEach((data: EventDTO, index: number) => {
                Moment.locale('pt-PT');
                const dataInicio = Moment(data.data_inicio).format('LL');
                const dataFim = Moment(data.data_fim).format('LL');
                content = (
                    <div key={index} className={classNames(['cell', 'medium-4', 'pacotesOferta'])}>
                        <div className={'card'}>
                            <div className={classNames(['card-section', 'mensagem'])}>
                                <p>{data.name}</p>
                            </div>
                            <div className={classNames(['card-section', 'info'])}>
                                {dataInicio === dataFim ?
                                    <span className={'info'}>{dataInicio}</span> :
                                    <span className={'info'}>{dataInicio} {t('events:cards.dateSeparator')}<br />{dataFim}</span>
                                }
                            </div>
                            {data.url_inscricao_convite &&
                                <div className={'card-image'}>
                                    <a onClick={() => { redirectToSignup(data); }} className={classNames(['button', 'campanha'])} title={t('events:cards.signup')} href="#">{t('events:cards.signup')}</a>
                                </div>
                            }
                        </div>
                    </div>
                );
                table.push(content);
            });
            return (
                <div className={classNames(['grid-container', 'fluid', 'margin-top-2'])}>
                    <div className={classNames(['grid-x', 'grid-margin-x'])}>
                        {table}
                    </div>
                </div>
            );
        } else {
            return <h3>{t('events:noEvents')}</h3>;
        }
    };

    return (
        <React.Fragment>
            {!props.isCommunicating && !props.eventsError && buildEventsList()}
            <DisplayErrorMessage validation={props.eventsError} />
            <DisplayLoading validation={props.isCommunicating && !props.eventsError} />
            <CardsResizer anchorClasses={['card-section info', 'card-section mensagem', 'card card-image']} trigger1={props.events} />
        </React.Fragment>
    );
};

const mapStateToProps = (store: RootState) => ({
    isCommunicating: store.eventsState.getEvents.isCommunicating,
    events: store.eventsState.getEvents.data,
    eventsError: store.eventsState.getEvents.error,
    isFollowing: store.eventsState.followSignup.isCommunicating,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    serviceActions: Service.bindServiceActionCreators(config, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Events);
